import { ButtonHTMLAttributes, useState } from 'react'

import { Typography } from '~/ds-components'

import { useWindowDimensions } from '~/utils'

import { Container } from './styles'

type MultipleChoicePrizeProps = {
  value: string
} & ButtonHTMLAttributes<HTMLButtonElement>

export const MultipleChoicePrize = (props: MultipleChoicePrizeProps) => {
  const { value, onClick, ...rest } = props

  const { xxl } = useWindowDimensions()

  const [isSelected, setIsSelected] = useState(false)

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsSelected(true)
    if (onClick) onClick(event)
  }

  return (
    <Container isSelected={isSelected} onClick={handleClick} type="button" {...rest}>
      {isSelected && (
        <Typography
          as="span"
          color="white"
          display="block"
          variant={xxl ? '5xLarge' : '2xLarge'}
          sx={{ fontWeight: 600 }}
        >
          {value}
        </Typography>
      )}
    </Container>
  )
}
